import { Link } from "react-router-dom";
import bunny from "../assets/images/bunny.png";
import { CREATE } from "../services/consts";
import CardList from "../components/CardList";

function Home() {
    return(
        <div className="block">
            <div className="container">
                <div className="fixed-bottom">
                    <div className="cloud">
                    <div className="cloud cloud_second"></div>
                    <Link to={CREATE} className="button">NEW</Link> 
                    </div>
                    <img className="bunny" src={bunny} alt="bunny" />
                </div>
                <h1 className="title">Your notes</h1>
                <CardList />
            </div>
        </div>
    );
}

export default Home;